import { render, staticRenderFns } from "./pdc_former.vue?vue&type=template&id=b37fd692&"
import script from "./pdc_former.vue?vue&type=script&lang=js&"
export * from "./pdc_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports